export class VerificaPerfil {
    cotacao: any = <any>{};
    pedidoVenda: any = <any>{};
    transfPedCompra: any = <any>{};
    notaFiscalSaida: any = <any>{};
    recebeProd: any = <any>{};
    fechamento: any = <any>{};
    solicitacao: any = <any>{};
    cadastros: any = <any>{};
}